// Imported at build time from the Design Studio output. Do NOT fetch at runtime.
import menuConfigJson from '../data/menu-config.json';
import { designLinkToRoute, PAGE_REGISTRY } from './pageRoutes.js';

// Normalise the design-studio menu shape into something the React Navigation
// component can render. Each item: { label, route, pageId, icon, children }.
function normaliseNode(node) {
  if (!node) return null;
  const children = Array.isArray(node.Children)
    ? node.Children.map(normaliseNode).filter(Boolean)
    : [];
  return {
    label: node.Label,
    pageId: node.PageId,
    moduleId: node.ModuleId,
    icon: node.MenuIcon || null,
    route: node.PageLink ? designLinkToRoute(node.PageLink) : null,
    children,
  };
}

export const MENU_TREE = Array.isArray(menuConfigJson.Children)
  ? menuConfigJson.Children.map(normaliseNode).filter(Boolean)
  : [];

export const DEFAULT_MENU_ITEM = menuConfigJson.DefaultMenuItem
  ? normaliseNode(menuConfigJson.DefaultMenuItem)
  : null;

// Default landing route — falls back to first menu item if DefaultMenuItem has
// no PageLink (which is common — Design Studio uses it to mark the default).
export const DEFAULT_ROUTE = (() => {
  if (DEFAULT_MENU_ITEM?.route) return DEFAULT_MENU_ITEM.route;
  if (DEFAULT_MENU_ITEM?.pageId && PAGE_REGISTRY[DEFAULT_MENU_ITEM.pageId]) {
    return PAGE_REGISTRY[DEFAULT_MENU_ITEM.pageId].route;
  }
  const firstLeaf = (function findLeaf(nodes) {
    for (const n of nodes) {
      if (n.route) return n;
      if (n.children?.length) {
        const c = findLeaf(n.children);
        if (c) return c;
      }
    }
    return null;
  })(MENU_TREE);
  return firstLeaf?.route || '/dashboard';
})();

// Registry of React routes that have been wired into App.jsx. App registers
// every UC page it mounts via registerRoute() so the post-login redirect can
// tell whether to land on the Design Studio default page or on /dashboard.
export const REGISTERED_ROUTES = new Set(['/dashboard']);

export function registerRoute(route) {
  if (route) REGISTERED_ROUTES.add(route);
}

// Post-login landing target. Uses DEFAULT_ROUTE only if the page has been
// converted from RawHTMLDesign already; otherwise returns /dashboard so users
// see the welcome card instead of NotFound.
export function resolvePostLoginRoute() {
  if (REGISTERED_ROUTES.has(DEFAULT_ROUTE)) return DEFAULT_ROUTE;
  return '/dashboard';
}
